<template>
  <div>
    <el-popover class="avatar_popover" placement="bottom" trigger="hover" :visible-arrow="false" width="200">
      <div class="avatar_popover_content">
        <div class="content_top flex flex_direction">
          <h1 class="text_size_16 margin-bottom-10">{{ userInfo.username }}</h1>
          <h1 class="text_size_14 text_color_active">{{ roleName }}</h1>
        </div>
        <div class="content_bottom flex flex_direction">
          <div class="handle_item flex align_center" @click="isShowUpdatePwDialog = true">
            <i class="iconfont iconziyuan margin-right-20"></i>
            <h1 class="text_size_14">修改密码</h1>
          </div>
          <div class="handle_item flex align_center" @click="signOut">
            <i class="iconfont iconziyuan1 margin-right-20"></i>
            <h1 class="text_size_14">退出登录</h1>
          </div>
        </div>
      </div>
      <div slot="reference" class="avatar_popover_reference flex align_center cursor_pointer">
        <h1 class="text_color_white cursor-pointer">Hi，{{ userInfo.username }}</h1>
      </div>
    </el-popover>
    <el-dialog custom-class="my-el-dialog" :append-to-body="true" :visible.sync="isShowUpdatePwDialog" width="400px" top="200px" :show-close="false" :close-on-click-modal="false">
      <div slot="title">
        <p class="dialog_title">修改密码</p>
      </div>
      <div class="change-pw-content">
        <el-form ref="pwdForm" :model="passwordData" :rules="rules" size="small" label-position="left" label-width="120px">
          <el-form-item label="原密码" prop="old_password">
            <el-input type="password" v-model="passwordData.old_password"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="new_password">
            <el-input type="password" v-model="passwordData.new_password"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="confirm_password">
            <el-input type="password" v-model="passwordData.confirm_password"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="">
        <el-button size="small" @click="updatePwCanceled">取消</el-button>
        <el-button :loading="updatePwButtonLoading" size="small" type="primary" @click="confirmUpdatePw">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as api from '~/api'
import SHA256 from 'crypto-js/sha256'
import cookie from '~/utils/cookie'
export default {
  data () {
    var confirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.passwordData.new_password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      // 是否显示修改密码的dialog
      isShowUpdatePwDialog: false,
      // 确定修改密码时的button的loading
      updatePwButtonLoading: false,
      // 密码
      passwordData: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      // 密码的验证
      rules: {
        old_password: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        confirm_password: [
          { required: true, message: '请输入确认新密码', trigger: 'blur' },
          { validator: confirmPassword, trigger: 'blur' }
        ]
      },
      // 修改密码的Loading
      signOutButtonLoading: false
    }
  },
  computed: {
    // 用户详细信息
    userInfo () {
      // 用户详细信息
      return this.$store.state.userInfo
    },
    // 用户角色
    roleName () {
      return this.userInfo.admin_role.find(item => {
        return item.value === this.userInfo.role
      }).label
    }
  },
  methods: {
    // 取消修改密码
    updatePwCanceled () {
      this.isShowUpdatePwDialog = false
      this.$refs['pwdForm'].resetFields()
    },
    // 确定修改密码
    confirmUpdatePw () {
      this.$refs['pwdForm'].validate((valid) => {
        if (valid) {
          this.updatePwButtonLoading = true
          api.updatePassword({
            old_password: SHA256(this.passwordData.old_password).toString(),
            new_password: SHA256(this.passwordData.new_password).toString(),
            confirm_password: SHA256(this.passwordData.confirm_password).toString()
          }).then(res => {
            if (res.data.code === 0) {
              this.$message.success('修改密码成功')
              this.updatePwCanceled()
              // 退出
              this.signOut()
            } else {
              this.$message.error(res.data.message)
              this.updatePwCanceled()
            }
            this.updatePwButtonLoading = false
          }).catch(err => {
            this.updatePwCanceled()
            console.log(err)
            this.$message.error('网络错误，请检查网络设置')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 退出登录
    signOut () {
      this.signOutButtonLoading = true
      api.signOut().then(res => {
        if (res.data.code === 0) {
          console.log(res.data.data)
        }
        this.signOutHandel()
        this.signOutButtonLoading = false
      }).catch(err => {
        this.signOutHandel()
        this.signOutButtonLoading = false
        console.log(err)
      })
    },
    signOutHandel () {
      // 删除token
      cookie.remove('token')
      // 重置vuex中用户的信息
      this.$store.commit('SET_USER_INFO', {})
      this.$router.push('/login')
    }
  }
}
</script>
<style lang="scss" scoped>
  .avatar_popover_content {
    .content_top {
      width: 100%;
      height: 80px;
      padding: 20px 0 10px 20px;
      border-bottom: 1px solid $border-color-base;
      & > h1 {
        height: 20px;
      }
    }
    .content_bottom {
      width: 100%;
      height: 100px;
      padding: 0 0 20px 0;
      .handle_item {
        padding-left: 20px;
        height: 40px;
        transition: all 0.3s ease;
        cursor: pointer;
        &:hover {
          background-color: $--color-primary-light-9;
          color: $color-primary;
        }
      }
    }
  }
  .avatar_popover {
    .avatar_popover_reference {
      height: 50px;
      padding: 0 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/header/header-avatar.vue